module.exports = __webpack_public_path__ + "static/media/ea_results.7956550d.png";